<div  cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div style="float: right;" mat-dialog-actions>
    <button mat-raised-button value="Close" class="alert-button" [mat-dialog-close]="false">
      <mat-icon [title]="data.buttonCancel"> close </mat-icon></button>
    </div>
    <app-raster-depth id="dummy" [id]="data.id" [x]="data.x" [y]="data.y" [rasterIds]="data.rasterIds" (closeDialogEvent)="closeDialogRaster($event)"></app-raster-depth>
</div>
